"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AgentRole;
(function (AgentRole) {
    AgentRole["APPC"] = "APPC";
    AgentRole["FINANCE"] = "FINANCE";
    AgentRole["FIRM_BILLING"] = "FIRM_BILLING";
    AgentRole["CENTERS_MEMBERSHIP"] = "CENTERS_MEMBERSHIP";
    AgentRole["B2B_OPS"] = "B2B_OPS";
    AgentRole["RAVE_OPS"] = "RAVE_OPS";
    AgentRole["SYSTEM_LAMBDA_STANDING_ORDER"] = "SYSTEM_LAMBDA_STANDING_ORDER";
    AgentRole["GEC"] = "GEC";
    AgentRole["CLIENT_ADMIN"] = "CLIENT_ADMIN";
})(AgentRole = exports.AgentRole || (exports.AgentRole = {}));
var ProvisionBy;
(function (ProvisionBy) {
    ProvisionBy["AICPA"] = "aicpa";
    ProvisionBy["BILL_ONLY"] = "bill-only";
})(ProvisionBy = exports.ProvisionBy || (exports.ProvisionBy = {}));
var InvoicePresentationOptions;
(function (InvoicePresentationOptions) {
    InvoicePresentationOptions["LINE_ITEM_DETAIL"] = "Detail";
    InvoicePresentationOptions["ORDER_SUMMARY"] = "Summary";
})(InvoicePresentationOptions = exports.InvoicePresentationOptions || (exports.InvoicePresentationOptions = {}));
var SellingCompanyCodes;
(function (SellingCompanyCodes) {
    SellingCompanyCodes["Association"] = "1000";
    SellingCompanyCodes["Aicpa"] = "0001";
    SellingCompanyCodes["Cima"] = "2001";
})(SellingCompanyCodes = exports.SellingCompanyCodes || (exports.SellingCompanyCodes = {}));
var AccessiblePeriodDurations;
(function (AccessiblePeriodDurations) {
    AccessiblePeriodDurations[AccessiblePeriodDurations["ONE"] = 1] = "ONE";
    AccessiblePeriodDurations[AccessiblePeriodDurations["TWO"] = 2] = "TWO";
    AccessiblePeriodDurations[AccessiblePeriodDurations["THREE"] = 3] = "THREE";
    AccessiblePeriodDurations[AccessiblePeriodDurations["FIVE"] = 5] = "FIVE";
    AccessiblePeriodDurations[AccessiblePeriodDurations["SIX"] = 6] = "SIX";
})(AccessiblePeriodDurations = exports.AccessiblePeriodDurations || (exports.AccessiblePeriodDurations = {}));
var AccessiblePeriodDurationLabels;
(function (AccessiblePeriodDurationLabels) {
    AccessiblePeriodDurationLabels["ONE"] = "1";
    AccessiblePeriodDurationLabels["TWO"] = "2";
    AccessiblePeriodDurationLabels["THREE"] = "3";
    AccessiblePeriodDurationLabels["FIVE"] = "5";
    AccessiblePeriodDurationLabels["SIX"] = "6";
})(AccessiblePeriodDurationLabels = exports.AccessiblePeriodDurationLabels || (exports.AccessiblePeriodDurationLabels = {}));
var AccessiblePeriodTypes;
(function (AccessiblePeriodTypes) {
    AccessiblePeriodTypes["WEEK"] = "Week";
    AccessiblePeriodTypes["MONTH"] = "Month";
    AccessiblePeriodTypes["YEAR"] = "Year";
})(AccessiblePeriodTypes = exports.AccessiblePeriodTypes || (exports.AccessiblePeriodTypes = {}));
exports.currencyOptions = [
    { key: 1, text: 'Dollars ($)', value: 'USD' },
    { key: 2, text: 'Pounds (£)', value: 'GBP' },
    { key: 3, text: 'Euros (€)', value: 'EUR' },
];
var ReasonsCode;
(function (ReasonsCode) {
    ReasonsCode["CANCELLATION"] = "Cancellation";
    ReasonsCode["CUSTOMER_SERVICE_EXCEPTION"] = "Cust. service exception";
    ReasonsCode["DISC_NOT_RECEIVED"] = "Disc Not Received";
    ReasonsCode["GRATIS"] = "Gratis";
    ReasonsCode["OTHER"] = "Other";
})(ReasonsCode = exports.ReasonsCode || (exports.ReasonsCode = {}));
var OrganizationCapabilityType;
(function (OrganizationCapabilityType) {
    OrganizationCapabilityType["CIMA"] = "cima";
    OrganizationCapabilityType["AICPA"] = "aicpa";
})(OrganizationCapabilityType = exports.OrganizationCapabilityType || (exports.OrganizationCapabilityType = {}));
//# sourceMappingURL=index.js.map